// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"521ca6e1","793":"31d6cfe0","911":"31d6cfe0","988":"617bb4cc"}[chunkId] + ".chunk.css";
};